import { SearchInput } from "@/components/SearchInput";
import { ListToolbarProps } from "@/types/list";
import { ListToolbarActions } from "./ListToolbarActions";

export const ListToolbar = <TData,>({
	table,
	filterKey,
	tableName,
	customFilter,
	loading = false,
	refreshFunction,
	expandedRowPanelExport,
	actionCoppyUrl = false,
	hideToolbarActions = false,
}: ListToolbarProps<TData>) => {
	const tableState = table.getState();

	return (
		<div className="flex flex-wrap md:flex-nowrap items-end py-4 gap-2 md:gap-4">
			{filterKey && (
				<SearchInput
					value={(tableState.columnFilters.find(f => f.id === filterKey)?.value as string) ?? ""}
					onChange={value =>
						table.setColumnFilters(prev => {
							const others = prev.filter(filter => filter.id !== filterKey);
							return value ? [...others, { id: filterKey, value }] : others;
						})
					}
				/>
			)}
			{customFilter && <div className="flex items-center">{customFilter}</div>}
			{!hideToolbarActions && (
				<ListToolbarActions
					table={table}
					tableName={tableName}
					loading={loading}
					expandedRowPanelExport={expandedRowPanelExport}
					refreshFunction={refreshFunction}
					actionCoppyUrl={actionCoppyUrl}
				/>
			)}
		</div>
	);
};
